import {Component, ElementRef, OnInit} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: '.accordion-header',
  templateUrl: './accordion-header.component.html',
  styleUrls: ['./accordion-header.component.scss']
})
export class AccordionHeaderComponent implements OnInit {

  active$ = new BehaviorSubject(false);

  constructor(private element: ElementRef) {
  }

  ngOnInit() {
    this.element.nativeElement.onclick = this.toggleActive.bind(this);
    this.active$.next(this.element.nativeElement.classList.contains('active'));
  }

  toggleActive() {
    this.element.nativeElement.classList.toggle('active');
    this.active$.next(this.element.nativeElement.classList.contains('active'));
  }

}

